const transitionDurationMs = 100;
const wrapper = "_yr2w18kf67y";

export { transitionDurationMs, wrapper };
import "./notification-count.style.linaria.module.css";
//# sourceMappingURL=notification-count.style.js.map
